"use client";

import { useEffect } from "react";

export function ServiceWorkerRegister() {
  useEffect(() => {
    if (
      process.env.NODE_ENV !== "production" &&
      !process.env.NEXT_PUBLIC_ENABLE_SW
    )
      return;
    if (!("serviceWorker" in navigator)) return;

    const version =
      process.env.NEXT_PUBLIC_SW_VERSION ||
      process.env.NEXT_PUBLIC_BUILD_ID ||
      "1";

    navigator.serviceWorker.register(`/sw.js?v=${version}`).catch(() => {});
  }, []);
  return null;
}
